import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase} from '@angular/fire/database';
@Component({
  selector: 'app-services',
  templateUrl: './services.page.html',
  styleUrls: ['./services.page.scss'],
})
export class ServicesPage implements OnInit {
  data:any[] = [];
  haschuser:any[] = [];
  constructor( public afDB: AngularFireDatabase) { }

  ngOnInit() {
    
  }

  

}
